import { render, staticRenderFns } from "./select-organ.vue?vue&type=template&id=62e08525&scoped=true&"
import script from "./select-organ.vue?vue&type=script&lang=js&"
export * from "./select-organ.vue?vue&type=script&lang=js&"
import style0 from "./select-organ.vue?vue&type=style&index=0&id=62e08525&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62e08525",
  null
  
)

export default component.exports